
import React from 'react';
import PropTypes from 'prop-types';
import { Main } from './LoaderSmall.styles';

const LoaderSmall = ({
  width,
  height,
  className,
  reverseColor,
}) => {
  return (
    <Main
      width={width}
      height={height}
      reverseColor={reverseColor}
      className={className}
    />
  );
};

LoaderSmall.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

LoaderSmall.defaultProps = {
  width: 45,
  height: 45,
};

export default LoaderSmall;



// WEBPACK FOOTER //
// ./src/components/loaders/LoaderSmall/LoaderSmall.jsx